export const REFERRAL_POPULATE_FULL = ["referee", "referrer"];
export const REFERRAL_POPULATE_DEFAULT = ["referee"];
export const REFERRAL_POPULATE_LIST = ["referee"];
export const REFERRAL_POPULATE = {
    FULL: REFERRAL_POPULATE_FULL,
    DEFAULT: REFERRAL_POPULATE_DEFAULT,
    LIST: REFERRAL_POPULATE_LIST,
};
export const REFERRAL_CODE_POPULATE_FULL = ["referrer"];
export const REFERRAL_CODE_POPULATE_DEFAULT = [];
export const REFERRAL_CODE_POPULATE = {
    FULL: REFERRAL_CODE_POPULATE_FULL,
    DEFAULT: REFERRAL_CODE_POPULATE_DEFAULT,
};
// Note: REFERRER_POPULATE removed - use USER_POPULATE with referrals.* paths instead
